import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { createBrowserHistory } from 'history'
import $ from 'jquery'
import { Base64 } from 'js-base64'
import moment from "moment"
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Switch } from 'react-router'
import {
    Redirect,
    Route,
    Router,
} from 'react-router-dom'
import OnBoardingPage from '../../src/onboarding/pages/OnBoardingPage'
import ExternalSignIn from '../auth/externalsignin.component.jsx'
import ConnectRedirect from '../connect/connectredirect.component.jsx'
import IntegrationEdit from '../integration/edit.component.jsx'
import MyAccount from "../my-account/myAccount.component.jsx"
import AppRoutes from '../privateroutes.jsx'
import Guard from '../role/Guard.jsx'
import ShopifyAppContext from '../shopify/shopifyappcontext.js'
import EventBus from './EventBus.js'
import GlobalHelper from "./GlobalHelper.jsx"
import GoogleTagManagerTracking from './GoogleTagManagerTracking.jsx'
import AlertList from './alert/AlertList'
import EmbeddedNavBar from './layout/embeddednavbar.component.jsx'
import Header from './layout/header.component.jsx'
import SideBar from './layout/sidebar.component.jsx'

const queryString = require('query-string')

const supportedSignUpIntegrations = "ls-retail|shopify|shopify-expert-app"
const history = createBrowserHistory()

history.listen((location, action) => {
    EventBus.dispatch(EventBus.TopicHistoryChanged, {
        didRefresh: true,
        location: location,
        action: action,
    })
})

class PrivateApp extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            user: AppContext.getUserLoggedIn(),
            account: AppContext.getAccount(),
            subscription: null,
            error: '',
            showMenu: false,
            emptyFrame: props.emptyFrame || false,
        }
        this.closeError = this.closeError.bind(this)
        this.handleError = this.handleError.bind(this)
        this.handleEvents = this.handleEvents.bind(this)
        this.handleToggleMenu = this.handleToggleMenu.bind(this)
        this.minimize = this.minimize.bind(this)
        AppContext.getApiClient().registerErrorHandler(this.handleError)
        EventBus.listen(EventBus.TopicDashboardDisplay, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicuserCreated, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicHistoryPush, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicHistoryChanged, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicLandedOnPhone, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicQuoteCreated, 'main-component', this.handleEvents)
        for (let integrationKey in EventBus.TopicIntegrationRequested) {//listens to all the integration requested events
            if (EventBus.TopicIntegrationRequested.hasOwnProperty(integrationKey)) {
                EventBus.listen(EventBus.TopicIntegrationRequested[integrationKey], 'main-component', this.handleEvents)
            }
        }
        EventBus.listen(EventBus.TopicQuoteApproved, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicQuoteSent, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicQuoteCreated, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicUrlPathChange, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicInlineDescriptionEdit, 'main-component', this.handleEvents)
        EventBus.listen(EventBus.TopicOpenVideoCall, 'main-component', this.handleEvents)

        if (this.isAnalyticsEnabled()) {
            this.setupFullStory()
        }
    }

    componentDidMount() {
        AppContext.setCookie('_uid', AppContext.getUserLoggedIn().id)
        AppContext.setCookie('_p', window.location.pathname)
        const uri = queryString.parse(window.location.search)
        if (uri.berr) {
            try {
                const error = JSON.parse(Base64.decode(uri.berr))
                this.handleError(error)
            } catch (e) {
                console.log(e)
            }
        }
        AppContext.getApiClient().get('/subscriptions/' + AppContext.getAccount().id).then(r => {
            this.setState({
                subscription: !r.error ? r : null,
            }, () => {
                if (this.isAnalyticsEnabled() &&
                    (GlobalHelper.getResponsiveBreakpoint() != "xs" || AppContext.getAccount().attributes.status === 'trial')
                ) {
                    this.setupIntercom()
                }
            })
        })
    }

    isAnalyticsEnabled() {
        if (window.location.pathname.startsWith('/embed/')) {
            return false
        }
        return AppContext.getCookie('analytics') !== 'disabled'
    }


    getIntercomSettings() {
        const breakpoint = GlobalHelper.getResponsiveBreakpoint()
        let company = {
            id: this.state.user.attributes.accountId,
            name: AppContext.getAccount().attributes.companyName,
            created_at: AppContext.getAccount().attributes.createdAt,
            plan: AppContext.getAccount().attributes.subscriptionType,
            integrations: GlobalHelper.getAllActiveIntegrations().map(i => i.attributes.integrationKey).join(','),
            integration_lightspeed: GlobalHelper.hasLightspeedIntegration(),
            integration_quickbooks: GlobalHelper.hasQuickBooksIntegration(),
            integration_stripe: GlobalHelper.hasStripeIntegration(),
            integration_paysafe: GlobalHelper.hasPaysafeIntegration(),
            currency: AppContext.getAccount().attributes.currency,
            app_account_status: AppContext.getAccount().attributes.status,
            app_account_expired_at: AppContext.getAccount().attributes.expiredAt,
            created_from_integration: AppContext.getAccount().attributes.integrationKey,
        }
        if (this.state.subscription && this.state.subscription.attributes) {
            company.monthly_spend = this.state.subscription.attributes.monthlyTotalPrice
        }
        return {
            app_id: GlobalHelper.getIntercomAppId(),
            name: GlobalHelper.GetFormattedName(this.state.user),
            phone: this.state.user.attributes.phoneNumber,
            remote_created_at: this.state.user.attributes.createdAt,
            app_user_id: this.state.user.id,
            app_account_id: this.state.user.attributes.accountId,
            app_user_role: this.state.user.attributes.role.attributes.key,
            app_is_mobile: ['xs', 'sm'].includes(breakpoint),
            app_is_tablet: ['md', 'lg'].includes(breakpoint),
            app_is_desktop: ['xl'].includes(breakpoint),
            app_environment: AppContext.getOptions().environment,
            app_has_browser_extension: GlobalHelper.isBrowserExtensionInstalled(),
            language_override: AppContext.getLocale().language,
            email: this.state.user.attributes.email,
            integrations: GlobalHelper.getAllActiveIntegrations().map(i => i.attributes.integrationKey).join(','),
            user_id: this.state.user.id,
            company: company,
        }
    }

    setupIntercom() {
        window.Intercom("boot", {
            app_id: GlobalHelper.getIntercomAppId(),
        })
        window.intercomSettings = this.getIntercomSettings()
        window.Intercom("update")
    }

    isFullStoryRecordingForced() {
        const user = AppContext.getUserLoggedIn()
        if (!user) {
            return false
        }
        if (!user.attributes.recordInFullStoryUntilDate) {
            return false
        }
        const recordInFullStoryUntilDate = new Date(AppContext.getAccount().attributes.recordInFullStoryUntilDate)
        const now = new Date()
        return now.getTime() < recordInFullStoryUntilDate.getTime()
    }

    setupFullStory() {
        if (!AppContext.getAccount() || AppContext.getAccount().attributes.status === "demo") {
            return
        }
        if (AppContext.getOptions().environment !== "prod") {
            return
        }
        const user = AppContext.getUserLoggedIn()
        if (!user) {
            return
        }
        const forceRecording = this.isFullStoryRecordingForced()
        if (!forceRecording) {
            if (AppContext.getAccount().attributes.status !== "trial") {
                return
            }
            if (user.attributes.email.includes("quotemachine.com")) {
                return
            }
            if (user.attributes.email.includes("atelier35.ca")) {
                return
            }
        }

        window['_fs_is_outer_script'] = true;
        window['_fs_debug'] = false;
        window['_fs_host'] = 'fullstory.com';
        window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
        window['_fs_org'] = 'C7TKZ';
        window['_fs_namespace'] = 'FS';
        (function (m, n, e, t, l, o, g, y) {
            if (e in m) { if (m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'); } return; }
            g = m[e] = function (a, b, s) { g.q ? g.q.push([a, b, s]) : g._api(a, b, s); }; g.q = [];
            o = n.createElement(t); o.async = 1; o.crossOrigin = 'anonymous'; o.src = 'https://' + _fs_script;
            y = n.getElementsByTagName(t)[0]; y.parentNode.insertBefore(o, y);
            g.identify = function (i, v, s) { g(l, { uid: i }, s); if (v) g(l, v, s) }; g.setUserVars = function (v, s) { g(l, v, s) }; g.event = function (i, v, s) { g('event', { n: i, p: v }, s) };
            g.anonymize = function () { g.identify(!!0) };
            g.shutdown = function () { g("rec", !1) }; g.restart = function () { g("rec", !0) };
            g.log = function (a, b) { g("log", [a, b]) };
            g.consent = function (a) { g("consent", !arguments.length || a) };
            g.identifyAccount = function (i, v) { o = 'account'; v = v || {}; v.acctId = i; g(o, v) };
            g.clearUserCookie = function () { };
            g.setVars = function (n, p) { g('setVars', [n, p]); };
            g._w = {}; y = 'XMLHttpRequest'; g._w[y] = m[y]; y = 'fetch'; g._w[y] = m[y];
            if (m[y]) m[y] = function () { return g._w[y].apply(this, arguments) };
            g._v = "1.3.0";
        })(window, document, window['_fs_namespace'], 'script', 'user');

        FS.identify(user.id, {
            displayName: GlobalHelper.GetFormattedName(user),
            email: user.attributes.email,
            accountId_str: AppContext.getAccount().id,
            companyName_str: AppContext.getAccount().attributes.companyName,
            integrationKey_str: AppContext.getAccount().attributes.integrationKey,
        });
    }

    handleEvents(event) {
        let eventTopic = event.getTopic()

        if (this.isAnalyticsEnabled()) {
            if (Object.values(EventBus.TopicIntegrationRequested).indexOf(eventTopic) > -1) {
                window.Intercom('trackEvent', eventTopic, {
                    integration_key: event.getData().integrationKey
                })
            }
            switch (eventTopic) {
                case EventBus.TopicDashboardDisplay:
                    window.Intercom('trackEvent', 'dashboard-display', {
                        nb_quote: event.getData().nbQuotes,
                    })
                    break
                case EventBus.TopicInlineDescriptionEdit:
                    window.Intercom('trackEvent', 'inline-description-edit', {
                        type: event.getData().type,
                    })
                    break
                case EventBus.TopicuserCreated:
                    window.Intercom('trackEvent', 'user-created', {
                        user_id: event.getData().user.id,
                        email: event.getData().user.attributes.email,
                        firstName: event.getData().user.attributes.firstName,
                        lastName: event.getData().user.attributes.lastName,
                        language: event.getData().user.attributes.language
                    })
                    break
                case EventBus.TopicIntegrationRequested:
                    window.Intercom('trackEvent', 'integration-requested', {
                        integration_key: event.getData().integrationKey
                    })
                    break
                case EventBus.TopicQuoteCreated:
                    window.Intercom('trackEvent', 'quote-created')
                    break
                case EventBus.TopicQuoteApproved:
                    window.Intercom('trackEvent', 'quote-approved', {
                        quote_total_amount: parseFloat(event.getData().quote.attributes.totalAmount)
                    })
                    break
                case EventBus.TopicQuoteDeclined:
                    window.Intercom('trackEvent', 'quote-declined', {
                        quote_total_amount: parseFloat(event.getData().quote.attributes.totalAmount)
                    })
                    break
                case EventBus.TopicQuoteSent:
                    window.Intercom('trackEvent', 'quote-sent', {
                        quote_total_amount: parseFloat(event.getData().proposal.attributes.variables.quote.totalAmount)
                    })
                    break
                case EventBus.TopicLandedOnPhone:
                    window.Intercom('trackEvent', 'landed-on-phone', {
                        last_landed_at: Math.floor(Date.now() / 1000)
                    })
                    break
                case EventBus.TopicOpenVideoCall:
                    this.openJitsi(event.getData().roomName, event.getData().companyName, event.getData().userName)
                    break
                case EventBus.TopicHistoryChanged:
                    AppContext.setCookie('_p', location.pathname)
                    AppContext.setCookie('_uid', AppContext.getUserLoggedIn().id)
                    window.intercomSettings = this.getIntercomSettings()
                    window.Intercom("update")
                    break
            }
        }
        switch (eventTopic) {
            case EventBus.TopicHistoryPush:
                history.push(event.getData().path)
                break
            case EventBus.TopicHistoryChanged:
                if (event.getData().didRefresh) {
                    window.scrollTo(0, 0)
                }
                break
            case EventBus.TopicUrlPathChange:
                window.history.pushState(null, '', event.getData().path)
                EventBus.dispatch(EventBus.TopicHistoryChanged, {
                    didRefresh: false,
                    location: window.location,
                })
                break
        }
        if (ShopifyAppContext.history && event.getData()) {
            ShopifyAppContext.replaceCurrentHistory(event.getData().location)
        }

    }

    closeError() {
        $('#mainAlert').removeClass('show')
        $('#mainAlert').addClass('d-none')
    }

    handleToggleMenu() {
        this.setState({
            showMenu: !this.state.showMenu
        })
    }

    handleError(err) {
        let errorMessage = ''
        if (typeof err === "string") {
            errorMessage = err
        } else if (err.error) {
            errorMessage = err.error.message
        }
        if (err.error && err.error.code === '402') {
            // Ignore payment error
            return
        }
        if (errorMessage !== '' && err.error.code !== '500' && !err.error.canBeIgnored) {
            $('.main-error-message').html(errorMessage)
            $('#mainAlert').removeClass('d-none')
            $('#mainAlert').addClass('show')
            setTimeout(this.closeError, 5000)
        } else if (errorMessage !== '' && !err.error.canBeIgnored) {
            $('.main-error-message').html(errorMessage)
            $('#mainAlert').removeClass('d-none')
            $('#mainAlert').addClass('show')
            setTimeout(this.closeError, 60000)
        }
    }

    openJitsi(roomName, companyName, userName) {
        const domain = 'meet.jit.si';
        const options = {
            roomName: roomName,
            width: 600,
            height: 400,
            interfaceConfigOverwrite: {
                APP_NAME: 'QuoteMachine',
                DEFAULT_REMOTE_DISPLAY_NAME: companyName,
                // DEFAULT_REMOTE_DISPLAY_NAME: this.state.variables.company.name,
                GENERATE_ROOMNAMES_ON_WELCOME_PAGE: false,
                DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
                DISABLE_FOCUS_INDICATOR: true,
                DISABLE_DOMINANT_SPEAKER_INDICATOR: true,
                DISABLE_PRESENCE_STATUS: true,
                DISABLE_TRANSCRIPTION_SUBTITLES: true,
                DISPLAY_WELCOME_PAGE_CONTENT: false,
                DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT: false,
                HIDE_INVITE_MORE_HEADER: true,
                SHOW_CHROME_EXTENSION_BANNER: false,
                TOOLBAR_BUTTONS: [
                    'microphone', 'camera', 'hangup',
                ],
            },
            parentNode: document.querySelector('#jitsi')
        };
        this.api = new JitsiMeetExternalAPI(domain, options)
        this.api.executeCommand('displayName', userName)
        this.api.addEventListener('videoConferenceLeft', (room) => {
            this.api.dispose()
        })
        this.api.addEventListener('videoConferenceJoined', (room) => {
            this.api.resizeLargeVideo(200, 140)
            $('#jitsi iframe').width(200)
            $('#jitsi iframe').height(140)
        })
        $('#jitsi').removeClass('d-none')
    }

    minimize(e) {
        e.preventDefault()
        if (!this.api) {
            return
        }
        if ($('#jitsi iframe').width() == 200) {
            this.api.resizeLargeVideo(600, 400)
            $('#jitsi iframe').width(600)
            $('#jitsi iframe').height(400)
        } else {
            this.api.resizeLargeVideo(200, 150)
            $('#jitsi iframe').width(200)
            $('#jitsi iframe').height(150)
        }

    }

    renderEmbeddedApp(content) {
        let mainClassName = "col-lg-12 mx-auto col-xl-11 pt-3"
        let containerClass = "container-fluid app-container"

        return <Router history={history} >
            <div>
                <div id="QuoteMachineApp" className={containerClass} app-account-id={this.state.account.id} app-user-id={this.state.user.id} app-account-company-name={this.state.account.attributes.companyName} >
                    <div className="row">
                        {
                            AppContext.getAccount().attributes.onBoardingStatus !== "pending" &&
                            < EmbeddedNavBar />
                        }
                        <main role="main" className={mainClassName}>
                            {content}
                            <footer className="footer text-center">
                                © {new Date().getFullYear()} QuoteMachine
                            </footer>
                        </main>
                    </div>
                </div>
                <div className="jitsi-frame jitsi-frame-top-right d-flex justify-content-center align-items-center p-1 d-none" id={'jitsi'} />
            </div>
        </Router >
    }

    render() {
        if (GlobalHelper.getResponsiveBreakpoint() == "xs") {
            //if we're smaller than sm, we log an event in intercom as we want to know this user has just had a bad experience
            EventBus.dispatch(EventBus.TopicLandedOnPhone)
        }

        var content = <div className="content">
            <div id={'mainAlert'} style={{
                zIndex: 9999,
            }} className="alert alert-danger alert-dismissible alert-dismissible fade d-none fixed-top mt-5 w-75 mx-auto" role="alert" tabIndex="0">
                <strong className={'mr-2'}>
                    <FormattedMessage
                        id="main.error.title"
                        defaultMessage="Oops!"
                    />
                </strong>
                <span className={'main-error-message'} />
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            {AppRoutes.map((route, index) => {
                let componentToLoad = (!route.feature || AppContext.accountFeatureIsEnabled(route.feature)) ? route.main : () => <Redirect to={"/my-account?utm_source=" + route.feature} />

                if (route.requiredPermissions && route.requiredPermissions.length > 0) {
                    for (let permission of route.requiredPermissions) {
                        if (!Guard.isAuthorized(permission)) {
                            if (typeof route.getDefaultRedirectPath === 'function') {
                                componentToLoad = () => <Redirect to={route.getDefaultRedirectPath()} />
                            } else {
                                componentToLoad = () => <Redirect to={'/'} />
                            }
                            break
                        }
                    }
                }

                return <div key={index} className="main-container">
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={this.isAnalyticsEnabled() ? GoogleTagManagerTracking(componentToLoad) : componentToLoad}
                    />
                </div>
            })}
        </div>

        let redirect = ''
        const today = moment()
        const expirationDate = moment(AppContext.getAccount().attributes.expiredAt)
        const accountGracePeriodInDays = AppContext.getAccount().attributes.gracePeriodInDays
        const expirationDatePlusGracePeriod = moment(expirationDate).add(accountGracePeriodInDays, 'days')
        const isOnBoarding = AppContext.getAccount().attributes.onBoardingStatus === "pending"

        if ((['trial'].includes(AppContext.getAccount().attributes.status) && expirationDate < today) ||
            (['expired'].includes(AppContext.getAccount().attributes.status) && expirationDatePlusGracePeriod < today) ||
            ['churned'].includes(AppContext.getAccount().attributes.status)) {
            content = <div className="content">
                <Switch>
                    <Route
                        key={1}
                        path={`/embed/connect/:integrationKey(${supportedSignUpIntegrations})`}
                        exact={true}
                        component={this.isAnalyticsEnabled() ? GoogleTagManagerTracking(ConnectRedirect) : ConnectRedirect}
                    />
                    <Route
                        key={2}
                        path={'/integrations/edit/:integrationId'}
                        exact={true}
                        component={this.isAnalyticsEnabled() ? GoogleTagManagerTracking(IntegrationEdit) : IntegrationEdit}
                    />
                    <Route
                        key={3}
                        path={`/p/signin/:integrationKey(${supportedSignUpIntegrations})`}
                        exact={true}
                        component={this.isAnalyticsEnabled() ? GoogleTagManagerTracking(ExternalSignIn) : ExternalSignIn}
                    />
                    {
                    isOnBoarding ?
                    <Route
                        key={4}
                        component={this.isAnalyticsEnabled() ? GoogleTagManagerTracking(OnBoardingPage) : OnBoardingPage}
                    /> : <Route
                    key={4}
                    component={this.isAnalyticsEnabled() ? GoogleTagManagerTracking(MyAccount) : MyAccount}
                />}
                </Switch>
            </div>
        }

        if( ['disabled'].includes(AppContext.getAccount().attributes.status)) {
            content = <div className="content">
                <Switch>
                    <Route
                        key={1}
                        component={this.isAnalyticsEnabled() ? GoogleTagManagerTracking(MyAccount) : MyAccount}
                    />
                </Switch>
            </div>
        }

        if (window.self !== window.top && GlobalHelper.getShopifyIntegrationOrigin()) {
            return this.renderEmbeddedApp(content)
        }

        let mainClassName = !isOnBoarding ? "col-lg-12 mx-auto col-xl-11 pt-3 px-4" : "m-auto col-xl-10 col-12 pt-3 px-4"
        let containerClass = "container-fluid app-container"
        if (this.state.emptyFrame) {
            mainClassName = "col-lg-12 mx-auto col-xl-12 pt-2 px-0"
            containerClass = "container-fluid"
        }

        return (
            <Router history={history}>
                <div>
                    {redirect}
                    {!this.state.emptyFrame ? <Header onToggleMenu={this.handleToggleMenu} /> : null}
                    <div id="QuoteMachineApp" className={containerClass} app-account-id={this.state.account.id} app-user-id={this.state.user.id} app-account-company-name={this.state.account.attributes.companyName} >
                        <div className="row">
                            {!isOnBoarding && !this.state.emptyFrame && <SideBar showMenu={this.state.showMenu} onToggleMenu={this.handleToggleMenu} />}
                            <main role="main" className={mainClassName}>
                                <AlertList />
                                {content}
                                {!this.state.emptyFrame ? <footer className="footer text-center">
                                    © {new Date().getFullYear()} QuoteMachine
                                </footer> : null}
                            </main>
                        </div>
                    </div>
                    <div className="jitsi-frame jitsi-frame-top-right d-flex justify-content-center align-items-center p-1 d-none" id={'jitsi'} />
                </div>
            </Router>
        );
    }
}

export default PrivateApp


// WEBPACK FOOTER //
// ./src/common/privateapp.component.jsx